import employee from "./employee"

export default {
  employee,
  warn_readonly: "Dies ist die lesende Ansicht. Bitte erzeugen sie einen Zugriffscode um das Formular zu beabeiten. <br/>Nachdem das Formular ausgefüllt wurde, können Sie auf den Refresh-Button (<i class='fas fa-sync'></i>) klicken, um die Eingaben zu prüfen."
}
